import React from 'react';
import {
  Card, CardContent, Typography, Box,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow
} from '@material-ui/core';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import RemoveIcon from '@material-ui/icons/Remove';

const VariationCell = ({ variation }) => {
  if (variation === null || variation === undefined) return <span>-</span>;

  const isPositive = variation > 0;
  const isNegative = variation < 0;

  const color = isPositive ? '#4caf50' : isNegative ? '#f44336' : '#9e9e9e';
  const Icon = isPositive ? TrendingUpIcon : isNegative ? TrendingDownIcon : RemoveIcon;

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" style={{ color }}>
      <Icon style={{ fontSize: 16, marginRight: 2 }} />
      <span style={{ fontWeight: 500 }}>
        {isPositive ? '+' : ''}{variation.toFixed(1)}%
      </span>
    </Box>
  );
};

const RankingTable = ({
  title,
  subtitle,
  data = [],
  onRowClick,
  formatCurrency = (v) => `${v.toFixed(2)} €`,
  commissionRate = 0.1
}) => {
  return (
    <Card style={{ height: '100%' }}>
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: 8 }}>
            {subtitle}
          </Typography>
        )}
        <TableContainer style={{ maxHeight: 400 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Établissement</TableCell>
                <TableCell align="right">Commandes</TableCell>
                <TableCell align="right">Évol. Cmd</TableCell>
                <TableCell align="right">CA Total</TableCell>
                <TableCell align="right">Marge nette (10%)</TableCell>
                <TableCell align="right">Évol. CA</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => {
                const revenue = Number(row.ca) || 0;
                const netMargin = revenue * commissionRate;

                return (
                  <TableRow
                    key={row.id}
                    hover
                    onClick={() => onRowClick?.(row)}
                    style={{ cursor: onRowClick ? 'pointer' : 'default' }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell align="right">{row.nb_commandes}</TableCell>
                    <TableCell align="right">
                      <VariationCell variation={row.variation_commandes} />
                    </TableCell>
                    <TableCell align="right">{formatCurrency(row.ca)}</TableCell>
                    <TableCell align="right">{formatCurrency(netMargin)}</TableCell>
                    <TableCell align="right">
                      <VariationCell variation={row.variation_ca} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default RankingTable;
